import { render } from "./OfferingDetails.vue?vue&type=template&id=278c967e&scoped=true"
import script from "./OfferingDetails.vue?vue&type=script&lang=js"
export * from "./OfferingDetails.vue?vue&type=script&lang=js"

import "./OfferingDetails.vue?vue&type=style&index=0&id=278c967e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-278c967e"

export default script